// let API_URL="https://sore-pink-chiton-hose.cyclic.app"
let API_URL="http://localhost:8001"

export default API_URL